var lib = require('./lib/')
module.exports = lib.default
module.exports.ERRORS = lib.ERRORS
